export class FeatureSearchConstants {
    static COMPONENT_NAME = "FeatureSearch";
    static PARENT_COMPONENT_NAME = "FeatureSearchComponent";
    static PAGE_HEADING = "Search";
    static SEARCH_OPTION_CONTROL = "searchOptionFromControl";
    static SELECT_COLUMN_OPTION_CONTROL = "selectColumnOptionFormControl";
    static SELECT_FILTER_OPTION_CONTROL = "selectFilterOptionFormControl";
    static SEARCH_OPTION_CONTROL_LABEL = "Select search:";
    static SELECT_COLUMN_OPTION_CONTROL_LABEL = "Select display fields:";
    static SELECT_FILTER_OPTION_CONTROL_LABEL = "Select filter fields:";
    static QUERY_BUILDER_HEADING_LABEL = "Search query builder";
    static MAP_HEADING_LABEL = "Map";
    static SEARCH_RESULTS_HEADING_LABEL = "Search results";
    static SELECT_ALL_LABEL = "Select all";
    static RESET_LABEL = "Reset";
    static SEARCH_LABEL = "Search";
    static SHOW_HIDE_COLUMNS_LABEL = "Show/hide display columns";
    static SHOW_HIDE_FILTERS_LABEL = "Show/hide filters";
    static FILTER_NAME_TEXT = "Field name";
    static FILTER_OPERATOR_TEXT = "Operator";
    static VALUE_OPERATOR_TEXT = "Value";
    static LOOKUP_VALUE_PLACEHOLDER = "Select lookup value";
    static SELECTED_PROPERTY_GRAPHICS_LAYER = "selectedPropertyGraphicsLayer";
    static ZONING_LOOKUP = "Zoning";
    static CREATE_APPLICATION_LIST = {
        modules: [
            "tp", "bp", "bpi", "dm", "pl", "tm", "w", "a", "bl", "ec", "rc", "sn", "zc", "gt"
        ]
    };
    static DESCRIPTION_LABEL1 = "Please select the layer you would like to search in the select search dropdown, if only on layer is available it will be selected by default.";
    static DESCRIPTION_LABEL2 = "Select the fields you would like to show in the results from the list of fields in the 'select search results fields' column by ticking the checkbox next to the field name, you have to select at least one field to show in your result set.";
    static DESCRIPTION_LABEL3 = "Enter a value in the input field shown next to the selected result field in the 'Filter output fields by' column to filter the results by the value, a filter has to be applied to at least one field.";
    static NO_SEARCH_SELECTED = "Please select a search option";
    static NO_SEARCHES_MESSAGE = "No searches configured, please contact your system administrator.";
    static MINIMUM_SELECTION_MESSAGE_FIELDS = "Please select at minimum one field to include in the search result.";
    static MINIMUM_SELECTION_MESSAGE_FILTER = "Please filter by at minimum one field to search.";
}
